import { connect } from "react-redux";
import {
    resendBulkSubscriptionConfirmationEmail,
    clearConfirmationEmailMessage
} from "../../../ducks/account";
import REDUX_ERROR_TYPES from "constants/ReduxErrorTypes";

import VerifyBulkSubscription from "../../../components/v2/bulk-subscriptions/VerifyBulkSubscription";

export function mapStateToProps(state) {
    const {
        account = {}
    } = state;

    return {
        titleText: "Link Expired",
        subTitleText: "The link you have activated is no longer valid.",
        resendConfirmationEmailSuccessMessage: account.resendConfirmationEmailSuccessMessage,
        resendConfirmationEmailErrorMessage: account.errors[REDUX_ERROR_TYPES.RESEND_CONFIRMATION_EMAIL],
        bloombergSiteUrl: state.config.bloombergSiteUrl
    };
}

export function mapDispatchToProps(dispatch) {
    return {
        resendBulkSubscriptionConfirmationEmail(email, resetPassword) {
            dispatch(resendBulkSubscriptionConfirmationEmail(email, resetPassword));
        },

        clearConfirmationEmailMessage() {
            dispatch(clearConfirmationEmailMessage());
        }
    };
}

const VerifyBulkSubscriptionContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(VerifyBulkSubscription);

export default VerifyBulkSubscriptionContainer;
